import dayjs from "dayjs";

const KEY_MEMBER = "COFFEE_STATS";
const KEY_ADMIN = "COFFEE_ADMIN_STATS";

var stats = (function () {
  
  function stats() {
  }

  stats.init = async function(key, numOfDays, getDayStat) {
    const today = new dayjs();
    var todayS = today.format('YYYY-MM-DD');
    

    var SSS = this.get(key);
    if (SSS == null) {
        // Inizialize stats
        SSS = { };
    }  else {
        // Remove old info from stats
        var first = today.subtract(numOfDays, "day").format('YYYY-MM-DD');
        var keys = Object.keys(SSS); 
        keys.sort();
        for (var i=0; i<keys.length; i++) { 
            var curKey = keys[i];
            if (curKey < first) { 
                console.log("Removing value for " + curKey + " ...");
                delete SSS[curKey];

                console.log(Object.keys(SSS).length);
            }  
        }
    }

    var listOfStats = [];
    for (var i=numOfDays; i>0; i--) {
        var day = today.subtract(i, "day");
        var dayS = day.format('YYYY-MM-DD');

        if (dayS in SSS) {
            if (dayS == SSS[dayS].created_at) { 
                console.log("Replacing value for " + dayS + " ...");
                delete SSS[dayS];
                listOfStats.push(getDayStat(dayS));
            }  else {
                //console.log(dayS + " is already present");
                //console.log(dayS + " is already present (%o)", SSS[dayS]);
                if (SSS[dayS].mark == undefined) {
                    console.log(dayS + " need to be invalidated (%o)...", SSS[dayS]);
                    delete SSS[dayS];
                    listOfStats.push(getDayStat(dayS));
                }
            }
        } else {
            console.log("Adding value for " + dayS + " ...");
            listOfStats.push(getDayStat(dayS));
        }          
    }
    listOfStats.push(getDayStat(todayS));
    //console.log("LIST of Promise");
    //console.log(listOfStats);

    await  Promise.all(listOfStats).then((docs) => { 
        let u = docs[0]; 
        let c = docs[1];
        //console.log("LIST of Stats");
        //console.log(docs);

        for (var i=0; i<docs.length; i++) {
            SSS[docs[i].day] = docs[i];
        }

        //console.log("DICT of Stats");
        //console.log(SSS);
        this.set(key, SSS);
    }).catch((err) => {
        console.error(err);
    });

    //for (var i=numOfDays; i>0; i--) {
    //    var day = today.subtract(i, "day");
    //    var dayS = day.format('YYYY-MM-DD');
//
    //    if (dayS in SSS) {
    //        if (dayS == SSS[dayS].created_at) { 
    //            console.log("Replacing value for " + dayS + " ...");
    //            delete SSS[dayS];
    //            var s = getDayStat(dayS);
    //            SSS[dayS] = { "day": day.locale('it-ch').format('dd DD'), "drink": s.drink, "offer": s.offer, "created_at": todayS};
    //        }  else {
    //            //console.log(dayS + " is already present");
    //        }
    //    } else {
    //        console.log("Adding value for " + dayS + " ...");
    //        var s = getDayStat(dayS);
    //        SSS[dayS] = { "day": day.locale('it-ch').format('dd DD'), "drink": s.drink, "offer": s.offer, "created_at": todayS};
    //    }          
    //}
//
    //
    //console.log("Updating values for today (" + todayS + ") ...");
    //var s = getDayStat(todayS);
    //SSS[todayS] = { "day": "oggi", "drink": s.drink, "offer": s.offer, "created_at": todayS};

    //this.set(SSS);
  };

  stats.update = async function(key, numOfDays, getDayStat) {
    var data;
    await stats.init(key, numOfDays, getDayStat).then(() => { 
        console.log("Stats inizialized...");
        data = stats.get(key);
    });

    return data;
  };

  stats.get = function (key) {
      if (!this.checkEnableLocalStorage())
          return null;

      var data = localStorage.getItem(key);
      if (data == null)
          return null;

      return JSON.parse(data);
  };

  stats.set = function (key, value) {
      if (!this.checkEnableLocalStorage())
          return;

      localStorage.setItem(key, JSON.stringify(value));
  };

  stats.remove = function (key) {
      if (!this.checkEnableLocalStorage())
          return null;
      localStorage.removeItem(key);
  };


  stats.checkEnableLocalStorage = function () {
      return typeof localStorage !== 'undefined';
  };

  return stats;
})();

export {stats, KEY_MEMBER, KEY_ADMIN}